'use client'

import * as React from 'react'

import { env } from '@/lib/env'

import type { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import type { TranslationEntry, TranslationLanguage } from '@/lib/translate'

interface ContextProps {
  language: TranslationLanguage
  setLanguage: Dispatch<SetStateAction<TranslationLanguage>>
}

interface TranslationContextProviderProps extends PropsWithChildren {
  translations: TranslationEntry[]
  forcedLanguage?: TranslationLanguage
}

const defaultLanguage = (env.NEXT_PUBLIC_DEFAULT_LANGUAGE ?? 'dk') as TranslationLanguage
export const TranslationContext = React.createContext<TranslationEntry[]>([])
export const LanguageContext = React.createContext<ContextProps>({
  language: defaultLanguage,
  setLanguage: () => null,
})

export const TranslationContextProvider: React.FC<TranslationContextProviderProps> = ({
  translations: trans,
  children,
  forcedLanguage,
}) => {
  const [language, setLanguage] = React.useState(forcedLanguage ?? defaultLanguage)

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <TranslationContext.Provider value={trans}>{children}</TranslationContext.Provider>
    </LanguageContext.Provider>
  )
}
